import VueElementLoading from 'vue-element-loading';
import { BasicSelect, MultiSelect } from 'vue-search-select';
import CreateContractTemplate from './../createContractTemplate';
import Pagination from './../../../../shared/components/pagination';
import Template1 from './../../../../shared/components/Template1';
import CustomExpandableTable from './../../../../shared/components/customExpandableTable';
import MasterService from './../../../services/masterdata.service';
import CONSTANT from './../../../../shared/constants/constant';
import ContractTemplateView from './../contracttemplateview';
import Util from './../../../../shared/util/util';

export default {
  name: 'contractListing',
  components: {
    VueElementLoading,
    Pagination,
    BasicSelect,
    Template1,
    CreateContractTemplate,
    CustomExpandableTable,
    ContractTemplateView
  },
  data: function() {
    return {
      createContracts: false,
      isLoading: false,
      showCreateContractsFlag: false,
      createTemplatesFlag: false,
      contractid: '',
      clientstatus: '',
      type: 'CONTRACT_MASTER_TEMPLATE',
      clientId: '',
      currentPage: 1,
      pageCount: 0,
      totalPage: 0,
      offset: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      pageNo: 0,
      totalrows: 0,
      totalCount: 0,
      offset: 0,
      tableColumn: ['Template Name', 'Created By', 'Created Date','Last Modified By','Last Modified Date', 'Status', 'Action'],
      // innerTableColumn: ['name','id', 'dummylable', 'name1','id1', 'dummylable1'],
      tableItems: [],
      apiListingData: [],
      selectedEditRow: [],
      status:"",
      statusSearch:"",
      contractidSearch:"",
      statuslist:[{
        value : "1",
        text : 'Active'
      },{
        value : "0",
        text : 'Inactive'
      }],
      statusitem:{value:'',text:''},
    }
  },
  computed: {

  },
  mounted() {
    this.getContractListing()
  },
  methods: {
    selectedStatus(statusitem){
      this.statusitem = statusitem;
      this.status = this.statusitem.value;
    },
    searchContract(){
      this.currentPage = 1;
      this.offset = 0;
      this.contractidSearch = this.contractid;
      this.statusSearch = this.status;
      this.getContractListing();
    },
    resetContract(){
      this.currentPage = 1;
      this.offset = 0;
      this.contractid= "";
      this.contractidSearch= "";
      this.status= "";
      this.statusSearch= "";
      this.getContractListing();
    },
    async getContractListing() {
      try {
        let payload = {
          offset: this.offset,
          limit: this.pageLimit
        }
        if (this.contractidSearch) {
          payload.contracttemplatename = this.contractidSearch.trim()
        }
        if(this.statusSearch!=""){
          payload.status = this.statusSearch;
        }
        this.isLoading = true
        let result = await MasterService.getContractListing(payload)
        this.isLoading = false
        this.totalCount = result.data.data.count;
        this.apiListingData = result.data.data.rows;
        if(this.totalCount>0){
          this.tableItems = result.data.data.rows.map((el) => {
            return {
              'id': el.id,
              'Template Name': el.contracttemplatename,
              'Created By': el.createdby,
              'Created Date': Util.displayDateTimeFormat(el.createddate),
              'Last Modified By':el.lastmodifiedby,
              'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
              'Status': el.status,
              'Action': 'View Edit',
            }
          })
        }else{
          this.tableItems = [];
        }

        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }

      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) *this.pageLimit
      this.getContractListing();
    },
    showCreateContract() {
      this.selectedEditRow = []
      this.showCreateContractsFlag = true;
    },
    createTemplates() {
      this.createTemplatesFlag = true;
    },
    eventFromChild() {
      this.showCreateContractsFlag = false;
      this.currentPage = 1;
      this.offset = 0;
      this.getContractListing();
    },
    async activeAction(data) {
      try {
        this.isLoading = true;
        var item = this.apiListingData.find(item => item.id === data.id);
        var isactivestatus = item.status == 0 ? 1 : 0
        let inputPayload = {
          "id": data.id,
          "type": this.type,
          "status": isactivestatus
        }
        let result = await MasterService.changeStatus(inputPayload)
        if (result.data.code == 200) {
          if (result.data.data[0].status == 0) {
            this.$alert("Contract Template Activated Successfully!!", this.contractid, "success");
          } else {
            this.$alert("Contract Template Inactivated Successfully!!", this.contractid, "success");
          }
          this.getContractListing();
          this.isLoading = false;
        }
      } catch (err) {
        console.log(err);
      }
    },
    getCustomTableEvent(event) {
      if (event.actionType == "active") {
        this.$confirm("Are you sure to make Active/Inactive?", "", "question").then(() => {
          this.activeAction(event);
        }).catch((err) => {
          console.log(err)
        });
      } else if (event.actionType == "inactive") {
        this.$confirm("Are you sure to make Active/Inactive?", "", "question").then(() => {
          this.activeAction(event);
        }).catch((err) => {
          console.log(err)
        })
      }

      if (event.actionType == "view") {
        let selectedViewRow = this.apiListingData.filter(function(Items) {
          return Items.id == event.id;
        });
        selectedViewRow[0].view = true;
        this.selectedEditRow = {
          id: selectedViewRow[0].id,
          status: selectedViewRow[0].status,
          view: selectedViewRow[0].view,
        }
        this.selectedEditRow.ComponentName = CONSTANT.CONTRACT_TEMPLATE
        this.createTemplatesFlag = true;
      }
      if (event.actionType == "edit") {
        let selectedEditRow = this.apiListingData.filter(function(Items) {
          return Items.id == event.id;
        });
        selectedEditRow[0].view = false;
        this.selectedEditRow = selectedEditRow[0];
        this.showCreateContractsFlag = true;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/contracttemplate/contracttemplateListing/contracttemplateListing.component.js